import Api from "../../api"
import Utils from "../../helpers/utils"

function getDefaultState() {
  return {
    eventList: [],
    totalEvents: null,
  }
}

const instructorEvent = {
  namespaced: true,
  state: getDefaultState(),
  mutations: {
    FLUSH_STATE(state) {
      Object.assign(state, getDefaultState())
    },
    SET_EVENTS_LIST(state, eventList) {
      state.eventList = eventList
    },
    SET_EVENTS_TOTAL(state, total) {
      state.totalEvents = total
    },
  },
  actions: {
    flushState({ commit }) {
      commit("FLUSH_STATE")
    },
    async getEvent(ctx, slug) {
      let res = await Api.instructorEvent.getEvent(slug)
      return res.data
    },
    async getInstructorEventSummaryReviewDefinition(ctx, slug) {
      let res = await Api.instructorEvent.getInstructorEventSummaryReviewDefinition(slug)
      return res.data
    },
    async updateEvent(ctx, { slug, data }) {
      let res = await Api.instructorEvent.summarizeEvent(slug, data)
      return res.data
    },
    async getPastEvents(
      { commit, state, rootGetters },
      { daysAgo, unsummarizedOnly, usePagination = true, ignoreCanceled = false, myEventsOnly = false }
    ) {
      // :Number daysAgo: days ago to get the events from (e.g., 21 means all events 3 weeks ago until today)
      const startDateString = Utils.dateToApiString(
        Utils.addDaysToToday(-daysAgo)
      )
      const endDateString = Utils.dateToApiString(Utils.addDaysToToday(0))
      let params = {
        start_time__gte: startDateString,
        start_time__lte: endDateString,
      }
      if (usePagination) {
        params = { ...params, ...rootGetters["pagination/apiParams"] }
      }
      if (unsummarizedOnly) {
        params.has_summary = false
      }
      if (ignoreCanceled) {
        params.is_canceled = false
      }
      if (myEventsOnly) {
        params.instructor__slug = Utils.myUserSlug()
      }
      let res = await Api.instructorEvent.getSummaries(params)
      commit("SET_EVENTS_LIST", res.data.results)
      commit("SET_EVENTS_TOTAL", res.data.count)
      return state.eventList
    },
    async getMyEventCounts(ctx, { daysAgo }) {
      const startDateString = Utils.dateToApiString(
        Utils.addDaysToToday(-daysAgo)
      )
      const endDateString = Utils.dateToApiString(Utils.addDaysToToday(0))
      let params = {
        start_time__gte: startDateString,
        start_time__lte: endDateString,
        instructor__slug: Utils.myUserSlug(),
      }
      let res = await Api.instructorEvent.getSummariesCounts(params)
      return res.data
    }
  },
}

export default instructorEvent
